import React from 'react';
import PropTypes from 'prop-types';
import { Container } from '@mui/material';

function PageHeader({ title }) {
  return (
    <div className="page-header">
      <Container maxWidth="md">
        <h1>{title}</h1>
      </Container>
      <div className="bands">
        <img src="/bands.png" alt="Bands" />
      </div>
    </div>
  );
}

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
};

export default PageHeader;
